import { httpClient } from '@connectors/HttpClient'

import type { Creator } from '../types'

export const CreatorService = {
    list: async (): Promise<Creator[]> => {
        const response = await httpClient.axios.get('/admin/creators')
        return response.data
    }
}
